import CheckboxItem, { CheckboxItemProps } from './CheckboxItem';

export type { CheckboxItemProps };
export default CheckboxItem;
